import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./QuestionAndAnswers.css";
import { FaRegClock } from "react-icons/fa";
import { useDarkMode } from "../../contexts/DarkModeContext";
import { fetchInquiries } from "../../redux/slices/inquiriesSlice";
import { Link } from "react-router";

function QuestionAndAnswers() {
  const { isDarkMode } = useDarkMode();
  const dispatch = useDispatch();
  const { inquiries, loading, error } = useSelector((state) => state.inquiries);

  useEffect(() => {
    // Fetch first 6 inquiries for the home page
    dispatch(fetchInquiries({ page: 1, limit: 6 }));
  }, [dispatch]);

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "27 Jan, 2024";
    
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    } catch (error) {
      return "27 Jan, 2024";
    }
  };

  return (
    <section className={`qa-section ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="qa-header">
        <p className="qa-subtitle">سؤال وجواب علمي</p>
        <h2 className="qa-title">تابع اخر المنشورات والتعليقات</h2>
      </div>

      {loading ? (
        <div className="text-center my-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">جاري التحميل...</span>
          </div>
        </div>
      ) : (
        <div className="qa-grid">
          {inquiries.length > 0 ? (
            inquiries.map((item, index) => (
              <div className="qa-card" key={item.id || index}>
                <div className="qa-card-header d-flex  gap-3 ">
                  <img 
                    src={item.user_image || "https://randomuser.me/api/portraits/men/32.jpg"} 
                    alt={item.user_name || "مستخدم"}
                    className="qa-user-image"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      objectFit: "cover"
                    }}
                    onError={(e) => {
                      e.target.src = "https://randomuser.me/api/portraits/men/32.jpg";
                    }}
                  />
                  <div className="mt-1" >
                    <h6 className="qa-user-name mb-1" style={{ fontSize: "14px", fontWeight: "600" }}>
                      {item.user_name || "مستخدم"}
                    </h6>
                    <div className="qa-date">
                      <FaRegClock style={{ fontSize: "12px" }} />
                      <span style={{ fontSize: "12px" }}>{formatDate(item.created_at)}</span>
                    </div>
                  </div>
                </div>
                <p className="qa-question" style={{width : "339px", maxWidth : "100%"}}>
                  {item.text || "لماذا تظهر السماء باللون الأزرق خلال اليوم ولكن تتحول إلى اللون الأحمر والبرتقالي عند غروب الشمس؟"}
                </p>
                <Link to="/questions" className="qa-link">
                  تابع الإجابات ...
                </Link>
              </div>
            ))
          ) : (
            <div className="text-center w-100">
              <p>لا توجد أسئلة متاحة</p>
            </div>
          )}
        </div>
      )}

      <div className="qa-footer my-5">
        <Link to="/questions" className="more-btn text-decoration-none">
          عرض المزيد
        </Link>
      </div>
    </section>
  );
}

export default QuestionAndAnswers;
